import React from 'react';

export default function IconSettingLogout() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1667 14.8336H4.91667C4.59584 14.8336 4.33334 14.5711 4.33334 14.2503V3.75028C4.33334 3.42945 4.59584 3.16695 4.91667 3.16695H10.1667"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.83334 9.00029H14.8333"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5 6.20029L14.8333 9.00029L12.5 11.8003"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
